import { Button, Typography, Tooltip } from '@mui/material';
import React, { useRef, useEffect, useState } from 'react';

type TextEllipsisProps = {
  text: string;
  width: string;
  styles?: React.CSSProperties;
  line?: number;
  onClick?: () => void;
  active?: boolean;
  inputStyle?: React.CSSProperties;
};

export const TextEllipsis = ({
  text,
  width,
  styles,
  line = 1,
  onClick,
  active,
  inputStyle
}: TextEllipsisProps) => {
  const textRef = useRef<HTMLSpanElement | null>(null);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    const el = textRef.current;
    if (!el) return;
    // For multiline ellipsis, compare scrollHeight and clientHeight
    if (el.scrollHeight > el.clientHeight + 1) {
      setShowTooltip(true);
    } else {
      setShowTooltip(false);
    }
  }, [text, width, line, styles]);

  const content = onClick ? (
    <Button
      onClick={onClick}
      style={{
        padding: '0',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'flex-start',
        height: '100%',
        minHeight: '50px',
        backgroundColor: active ? '#00000030' : 'transparent',
        ...styles
      }}>
      <Typography
        component="span"
        ref={textRef}
        style={{
          textAlign: 'left',
          width: width,
          display: '-webkit-box',
          WebkitBoxOrient: 'vertical',
          WebkitLineClamp: line,
          overflow: 'hidden',
          color: '#000',
          ...inputStyle
        }}>
        {text}
      </Typography>
    </Button>
  ) : (
    <Typography
      component="span"
      ref={textRef}
      style={{
        textAlign: 'left',
        width: width,
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: line,
        overflow: 'hidden',
        color: '#000',
        ...styles,
        ...inputStyle
      }}>
      {text}
    </Typography>
  );

  return showTooltip ? (
    <Tooltip title={text}>
      <span>{content}</span>
    </Tooltip>
  ) : (
    content
  );
};
